import React from 'react'

const Report = ({show}) => {
  return (
    <div className='content' style={{marginLeft: show ? '220px' : '10px'}}>Report</div>
  )
}

export default Report